import React from 'react';
import LogoLoader from './results/logo-loader';
import { useAuth } from '../../../providers/auth-provider';

function ReportPdfHeader() {
  const { slug } = useAuth();
  return (
    <div className="w-100 justify-content-center d-none bg-dark pb-3 report-pdf-header">
      <LogoLoader slug={slug} fileName={'banner-logo.png'} style={{ height: '48px' }} />
    </div>
  );
}

export default ReportPdfHeader;
